import { useMutation } from '@tanstack/react-query';
import instance from '@src/api/axiosInstance';

export function useCancelChat() {

  return useMutation(
    async ({ sessionId }: { sessionId: string }) => {
      const response = await instance.post('/nexa/chat/cancel', { session_id: sessionId });
      return response.data;
    },
    {
      onError: (error: any) => {
        console.error('Failed to cancel chat:', error);
      }
    }
  );
}
